// Front
import LayoutReducer from './layouts/reducer';

// login
import LoginReducer from './auth/login/reducer';

import customerReducer from './customers/reducer';

import orderReducer from './orders/reducer';

import serviceReducer from './services/reducer';

import expenseReducer from './expenses/reducer';
import publicReducer from './public/reducer';
import auditLogsReducer from './auditLogs/reducer';

// userProfile
import ProfileReducer from './auth/profile/reducer';
import reportReducer from './report/reducer';
import shiftReducer from './shift/reducer';

// Users
import { configureStore } from '@reduxjs/toolkit';
import UsersReducer from './users/reducer';

export const store = configureStore({
  reducer: {
    Layout: LayoutReducer,
    login: LoginReducer,
    Profile: ProfileReducer,
    users: UsersReducer,
    report: reportReducer,
    shift: shiftReducer,
    customer: customerReducer,
    order: orderReducer,
    service: serviceReducer,
    public: publicReducer,
    expense: expenseReducer,
    auditLogs: auditLogsReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export const appDispatch = () => store.dispatch;
